/**
 * KAN-918: "Новое сообщение" у взятого в работу клиента.
 *
 * Взятый клиент больше не возвращается в "Требуют внимания" по сообщениям.
 * Backend отдаёт new_message_at (ISO; null или нет поля: нового нет): последнее
 * сообщение клиента новее взятия и последнего ручного сообщения менеджера.
 * Одно правило для дашборда ("В работе") и приложения менеджера (/m).
 */
export interface WithNewMessage {
  new_message_at?: string | null;
}

export const NEW_MESSAGE_LABEL = 'Новое сообщение';

/** Есть сообщение клиента, на которое менеджер ещё не ответил. */
export function hasNewMessage(item: WithNewMessage): boolean {
  return !!item.new_message_at;
}

const time = (iso: string | null | undefined) => (iso ? new Date(iso).getTime() : 0);

/** Делит строки: с новым сообщением (свежее сверху) и остальные (порядок сохранён). */
export function splitNewMessages<T extends WithNewMessage>(items: readonly T[]): { fresh: T[]; rest: T[] } {
  const fresh = items.filter(hasNewMessage).sort((a, b) => time(b.new_message_at) - time(a.new_message_at));
  const rest = items.filter((item) => !hasNewMessage(item));
  return { fresh, rest };
}

/** Строки с новым сообщением сверху (свежее выше), остальные в прежнем порядке. */
export function newMessagesFirst<T extends WithNewMessage>(items: readonly T[]): T[] {
  const { fresh, rest } = splitNewMessages(items);
  return [...fresh, ...rest];
}
